import { Routes, Route } from "react-router-dom";
import HomePage from "features/home/HomePage";
import SubCategoriesPage from "features/categories/SubCategoriesPage";
import ProductsByCategoryPage from "features/products/ProductsByCategoryPage";
import ProductDetailsPage from "features/products/ProductDetailsPage";
import SearchPage from "features/search/SearchPage";
import OrderConfirmationPage from "features/orders/OrderConfirmationPage";
import OrdersPage from "features/orders/OrdersPage";
import OrderTrackingPage from "features/orders/OrderTrackingPage";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/categories/:categoryId" element={<SubCategoriesPage />} />
      <Route path="/category/:categoryId/products" element={<ProductsByCategoryPage />} />
      <Route path="/product/:productId" element={<ProductDetailsPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/order-confirmation/:orderId" element={<OrderConfirmationPage />} />
      <Route path="/orders" element={<OrdersPage />} />
      <Route path="/orders/:orderId" element={<OrderTrackingPage />} />
    </Routes>
  );
}
